import { Component, Field } from '@contember/interface'

export const TagsPreview = Component(() => (
	<div>
		<Field field="name" />
	</div>
))
